import React from "react";
import RestService from "../../services/api/RestService";
import i18n from "../../i18n/i18n";
import { enqueueSnackbar } from 'notistack'
import NotistackVariants from "../../components/snackbar/NotistackVariants";
import {
    Button,
    Divider,
    FormControl,
    FormControlLabel,
    FormLabel,
    Link,
    Radio,
    RadioGroup,
    Typography
} from "@mui/material";
import { withStyles } from 'tss-react/mui';
import {withTranslation} from "react-i18next";
import {simplifyLanguageSymbol} from "../../utils/LanguageSymbolSimplify";
import withRouter from "../../utils/withRouter";

const styles = theme => ({
    paper: {
        display: "flex",
        justifyContent: "center",
        textAlign: "center",
        color: theme.palette.text.secondary
    },
    divider: {
        margin: "15px 0"
    },
    group: {
        flexDirection: "row"
    },
    instructionParagraph: {
        marginBottom: "0.75em"
    },
    testDetails: {
        marginBottom: "30px"
    },
    withMargin: {
        marginBottom: "30px"
    },
});

class TestStartPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            testInfo: undefined,
            language: simplifyLanguageSymbol(i18n.language)
        };

        this.onStartTest = this.onStartTest.bind(this);
    }

    componentDidMount() {
        this.getTestInfo();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const simplifiedLanguage = simplifyLanguageSymbol(i18n.language)
        if(prevState.language !== simplifiedLanguage)
            this.setState({language: simplifiedLanguage})
    }

    getTestInfo() {
        RestService.getTestInfo(this.props.router.params.securityCode)
            .then(json => {
                this.setState({testInfo: json});
            })
            .catch(error => {
                enqueueSnackbar(error.message, NotistackVariants.error);
                this.props.router.navigate("/not_found");
            });
    }

    onStartTest() {
        this.props.router.navigate("/test/" + this.props.router.params.securityCode);
    }

    handleLanguageChange = event => {
        let newLanguage = event.target.value;
        this.setState({language: newLanguage});
        i18n.changeLanguage(newLanguage).then();
    };

    render() {
        const {classes} = this.props;

        if (this.state.testInfo === undefined) {
            return null;
        }

        const testInfo = this.state.testInfo;
        const language = this.state.language;

        const testStartTime = new Date(`${testInfo.timeWindowOpenTime}`);
        const testEndTime = new Date(`${testInfo.timeWindowCloseTime}`);

        return (
            <>
                <div className={classes.paper}>
                    <FormControl component="fieldset"
                                 className={classes.formControl}>
                        <FormLabel component="legend">
                            {i18n.t("testStartPage:selectLanguage")}
                        </FormLabel>
                        <RadioGroup className={classes.group}
                                    value={this.state.language}
                                    onChange={this.handleLanguageChange}>
                            <FormControlLabel value="en"
                                              control={<Radio/>}
                                              label="English"/>
                            <FormControlLabel value="pl"
                                              control={<Radio/>}
                                              label="Polski"/>
                        </RadioGroup>
                    </FormControl>
                </div>

                <Typography variant="h3" gutterBottom={true}>
                    {i18n.t("testStartPage:hello", {name: `${testInfo.personFirstName}`})}
                </Typography>

                <Typography variant="body1" className={classes.instructionParagraph}>
                    {i18n.t("testStartPage:introduction.youAreAboutToSolve")}
                </Typography>

                <Typography variant="body1" className={classes.instructionParagraph}>
                    {i18n.t("testStartPage:introduction.tasksAndResultsAreShown")}
                </Typography>

                <Typography variant="body1" className={classes.instructionParagraph}>
                    {i18n.t("testStartPage:introduction.sendingASolution")}
                </Typography>

                <Typography variant="body1" className={classes.instructionParagraph}>
                    {i18n.t("testStartPage:introduction.warningNotToChangeNames")}
                </Typography>

                <Typography variant="body1" className={classes.instructionParagraph}>
                    {i18n.t("testStartPage:introduction.taskTimeAndOrder")}
                </Typography>

                <Typography variant="body1" className={classes.instructionParagraph}>
                    {i18n.t("testStartPage:introduction.solvingWithIde")}
                </Typography>

                <Typography variant="body1" className={classes.instructionParagraph}>
                    {i18n.t("testStartPage:introduction.inCaseOfQuestions")}
                </Typography>

                <Typography variant="body1" className={classes.instructionParagraph}>
                    {i18n.t("testStartPage:introduction.weJudgeNotOnlyCorrectness")}
                </Typography>

                <Typography variant="body1" className={classes.instructionParagraph}>
                    {i18n.t("testStartPage:introduction.goodLuck")}
                </Typography>

                <Typography variant="caption">
                    <Link data-cy="privacyPolicy" href={"#/privacy-policy"}>
                        {i18n.t("testStartPage:privacyPolicy")}
                    </Link>
                </Typography>

                <Divider className={classes.divider}/>

                <Typography variant="body1">
                    <b>{i18n.t("testStartPage:testOpenFrom")}:</b> {testStartTime.toLocaleString([language, "en"])}
                </Typography>
                <Typography variant="body1">
                    <b>{i18n.t("testStartPage:testClosesAt")}:</b> {testEndTime.toLocaleString([language, "en"])}
                </Typography>

                <Divider className={classes.divider}/>

                <div className={classes.testDetails}>
                    <Typography variant="body1">
                        <b>{i18n.t("testStartPage:numberOfTasks")}:</b> {testInfo.assignmentsNumber}
                    </Typography>
                    <Typography variant="body1">
                        <b>{i18n.t("testStartPage:testDuration")}:</b> {testInfo.testDurationInMinutes} {i18n.t("testStartPage:minutes")}
                    </Typography>
                </div>

                <Button color="secondary" variant="contained"
                        disabled={!testInfo.canBeSolved}
                        className={classes.withMargin}
                        onClick={this.onStartTest}>
                    {i18n.t("testStartPage:startTheTest")}
                </Button>
            </>
        );
    }
}

const TestStartPageWithStyles = withStyles(TestStartPage, styles);
const TestStartPageWithRouter = withRouter(TestStartPageWithStyles);
export default withTranslation()(TestStartPageWithRouter);